export interface MenuOption {
  icon: string;
  name: string;
  url: string;
  adminOnly?: boolean;
}

export const options_menu: MenuOption[] = [
  {
    icon: "../../assets/img/panel-captarmedia-01.png",
    name: "ESTADO",
    url: "home",
  },
  {
    icon: "../../assets/img/panel-captarmedia-02.png",
    name: " PROGRAMACIÓN",
    url: "programacion",
  },
  {
    icon: "../../assets/img/panel-captarmedia-04.png",
    name: "NOTICIAS",
    url: "noticias",
  },
  {
    icon: "../../assets/img/panel-captarmedia-06.png",
    name: "SETTINGS",
    url: "settings",
    adminOnly: true,
  },
];

// tipos de frames

export interface TipoFrame {
  id: number;
  type: string;
  type_title: string;
  descripcion: string;
  color: string;
  active: boolean;
  hide?: boolean;
}

export const types: TipoFrame[] = [
  {
    id: 2,
    type: "publicidad",
    type_title: "PUBLICIDAD",
    descripcion: "PUBLICIDAD (FULLSCREEN)",
    color: "#29abe2",
    active: true,
  },
  {
    id: 1,
    type: "contenido",
    type_title: "CONTENIDO",
    descripcion: "CONTENIDO (PANTALLA COMPARTIDA)",
    color: "#69358b",
    active: true,
  },
  {
    id: 4,
    type: "noticia",
    type_title: "NOTICIA",
    descripcion: "NOTICIA",
    color: "#69358b",
    active: true,
    hide: true,
  },
  {
    id: 7,
    type: "programado",
    type_title: "PROGRAMADO",
    descripcion: "PROGRAMADO (HORARIO ESTABLECIDO)",
    color: "#e95052",
    active: true,
    hide: true,
  },

  // id 9: noticia manual, se crea desde el frontend (upload-form)
  {
    id: 9,
    type: "news-frame",
    type_title: "NEWS FRAME",
    descripcion: "NOTICIA (MANUAL)",
    color: "#e95052",
    active: true,
  },
  {
    id: 3,
    type: "zocalo",
    type_title: "ZOCALO",
    descripcion: "ZOCALO",
    color: "#29abe2",
    active: true,
  },
  {
    id: 5,
    type: "url",
    type_title: "URL",
    descripcion: "URL",
    color: "#9e9e9e",
    active: true,
    hide: true,
  },
  {
    id: 6,
    type: "streaming",
    type_title: "STREAMING",
    descripcion: "STREAMING",
    color: "#9e9e9e",
    active: true,
    hide: true,
  },
  // id 8: noticia automatica (slots del generador RSS del backend), no se genera desde el frontend
  {
    id: 8,
    type: "news-frame",
    type_title: "NEWS FRAME",
    descripcion: "NOTICIA (AUTOMATICA)",
    color: "#e95052",
    active: true,
    hide: true,
  },
];

export const medias = [
  {
    id: 1,
    titulo: "Video",
    type: "video/mp4",
  },
  {
    id: 2,
    titulo: "Imagen",
    type: "image/png",
  },
  {
    id: 2,
    titulo: "Imagen",
    type: "image/jpeg",
  },
];

// Frontend-only etiqueta list; id 0 = circuit root ("Mi Circuito").
// User decision 2026-08-04: static literal, never derived from auth.circuito.
export const etiquetas = [{ id: 0, nombre: "Mi Circuito" }];



// WEBPACK FOOTER //
// ./src/app/providers/data.ts